export default __webpack_public_path__ + "fd4a934f2135332a8d4f43dd9ae5ab8c.png";